import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { ECouponDetail } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type ECouponDetailResponse = ECouponDetail;

export interface ECouponDataSource {
  getECouponDetail(eCouponId: string): Promise<ECouponDetailResponse>;
}

export class ECouponDataSourceImpl implements ECouponDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getECouponDetail(eCouponId: string) {
    return this.client.request<ECouponDetailResponse>({
      url: `/api/non-login/v1/e-coupon/${eCouponId}`,
      method: 'get',
    });
  }
}

export const eCouponDataSource = new ECouponDataSourceImpl();
